import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Dialog from '@shared/ui/molecules/Dialog';
import { BodyLarge, BodyRegular, BodySmall } from '@shared/ui/atoms/fonts/Body';
import './delete-team-dialog.scss';
import { closeDialog } from '@shared/store/dialog.duck';
import { TeamEntity } from '@shared/models/team.models';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { deleteTeamRequest } from '@shared/services/TeamService';
import { NotificationMessages, redirectWithNotification } from '@shared/models/notification.models';
import { failureNotification } from "../../store/notification.duck";
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { useTranslation } from "react-i18next";
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function DeleteTeamDialog(props: { payload?: { team?: TeamEntity } }) {
  const selectedTeam = props.payload?.team;
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const close = () => {
    dispatch(closeDialog());
  }
  const deleteTeam = () => {
    setIsLoading(true);
    deleteTeamRequest(selectedTeam?.id)
      .then(() => redirectWithNotification(NotificationMessages.teamDeleted, '/manage/teams-and-users'))
      .catch(() => failureNotification('Team failed to delete'))
      .finally(() => setIsLoading(false));
  }

  return (
    <Dialog isOpen={true} onClose={() => close()} className="deleteTeamDialog">
      <HeadlineMedium className="deleteTeamDialog__title">{t('delete-team-dialog.title')}</HeadlineMedium>
      {isLoading ?
        <LoadingSpinner hideBorder={true}/> :
        <>
          <BodyRegular className="deleteTeamDialog__message">{t('delete-team-dialog.description')}</BodyRegular>

          <div className="deleteTeamDialog__content">
            <Center>
              <BodyLarge weight={600} className="deleteTeamDialog__message">{selectedTeam?.name ?? ''}</BodyLarge>
            </Center>
          </div>

          <BodySmall className="deleteTeamDialog__info">{t('delete-team-dialog.warning-message')}</BodySmall>

          <PrimaryButton className="deleteTeamDialog__button"
                         fullWidth={true}
                         text="button.confirm-delete-team"
                         size={ButtonSize.Large}
                         click={() => deleteTeam()}/>
          <OutlineButton className="deleteTeamDialog__button deleteTeamDialog__cancelButton"
                         text="button.reject-delete-team"
                         size={ButtonSize.Large}
                         fullWidth={true}
                         click={() => close()}/>
        </>
      }
    </Dialog>
  )
}
